module.exports = __webpack_public_path__ + "img/info-circle.5f60a388.svg";